import { styled } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { ChannelsTabPdf } from "./channels/ChannelsTabPdf";
import { AllCompetitorsModalProvider } from "./channels/tables/components/AllCompetitorsModalContext";
import { PdfMetric } from "./components/Report/PdfMetric/PdfMetric";

const StyledReportWrapper = styled.div`
    background: ${colorsPalettes.bluegrey[100]};
    max-width: 1064px;

    @media print {
        padding: 0 44px;

        @page {
            padding: 24px 0;
        }

        .pageBreakBefore {
            break-before: page;
        }

        .avoidBreakInside {
            break-inside: avoid;
        }
    }
`;

export const BenchmarkReportPdf = () => (
    <AllCompetitorsModalProvider>
        <StyledReportWrapper>
            <PdfMetric />
            <ChannelsTabPdf />
        </StyledReportWrapper>
    </AllCompetitorsModalProvider>
);
